export const IRO_EBOOK_URLS: Record<string, string> = {
  es: 'https://statics.myhotel.cl/documents/EBooks/e-book+IRO+-+espan%CC%83ol.pdf',
  en: 'https://statics.myhotel.cl/documents/EBooks/e-book+IRO+-+ingle%CC%81s.pdf',
  pt: 'https://statics.myhotel.cl/documents/EBooks/e-book+IRO+-+portugue%CC%81s.pdf',
};

export function getIroEbookUrl(lang: string): string {
  return IRO_EBOOK_URLS[lang] ?? IRO_EBOOK_URLS.es;
}
